export const botPatterns = [/bot/i, /crawl/i, /spider/i, /google/i, /bing/i, /ahrefs/i, /semrush/i, /dotbot/i];
